module.exports = __webpack_public_path__ + "static/img/ico_denglu.b979bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico_denglu.png
// module id = Zi5K
// module chunks = 29